import React, { lazy } from 'react';
const ShowroomTypes = () => {
  const facilities = [{
    title: 'Montessori & Private Schools',
    description: 'Provide healthy hydration that aligns with your educational philosophy—teaching sustainability while keeping students focused and energized throughout the day.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6VdDKdAcKT38BXoFFKcoLd/Elementary_5.webp'
  }, {
    title: 'Elite Sports Academies & Training Centers',
    description: 'Fuel young athletes with electrolyte-infused options and vitamin waters that support peak performance, recovery, and proper hydration during intense training.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2VqKt3GxemcPE5kQAPWSdQ/University_11.webp'
  }, {
    title: 'After-School Programs & Enrichment Centers',
    description: 'Keep kids refreshed and engaged with delicious, healthy drink options while offering premium beverages for parents during pickup and special events.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wTUHD7HYz59D2RkehnsJU8/Elementary_4.webp'
  }, {
    title: 'Dance Studios & Performing Arts Schools',
    description: 'Support young performers with proper hydration before, during, and after classes—plus sophisticated options for parents attending recitals and performances.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jJjF9na4c11Q24BTP7BWou/University_4.webp'
  }, {
    title: 'Martial Arts & Youth Fitness Studios',
    description: 'Provide essential hydration for active kids while demonstrating your commitment to health, wellness, and environmental responsibility.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jN9JGv87Ex5StjuYCSpVyZ/Elementary_3.webp'
  }, {
    title: 'STEM Learning Centers & Coding Academies',
    description: 'Keep young minds sharp and focused with healthy hydration options that support concentration during intensive learning sessions and competitions.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mQCts7Bu7A2B6vBhbdDaUh/University_12.webp'
  }];
  return <section className="py-20 bg-gradient-to-b from-white to-blue-50" data-id="element-670">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-671">
        <div className="text-center mb-16" data-id="element-672">
          <span className="inline-block px-4 py-1.5 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-4" data-id="element-673">
            IDEAL ENVIRONMENTS
          </span>
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-674">
            Perfect for These Educational Facilities
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-675">
            Healthy hydration solutions designed for youth-focused environments
            where wellness and learning come first
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-676">
          {facilities.map((facility, index) => <div key={index} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-677">
              <div className="h-48 overflow-hidden" data-id="element-678">
                <img src={facility.image} alt={facility.title} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" width="400" height="300" loading="lazy" decoding="async" data-id="element-679" />
              </div>
              <div className="p-6" data-id="element-680">
                <h3 className="text-xl font-bold text-navy-950 mb-2" data-id="element-681">
                  {facility.title}
                </h3>
                <p className="text-gray-600" data-id="element-682">{facility.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-683">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-684">
            Find Your Perfect Solution
          </a>
        </div>
      </div>
    </section>;
};
export default ShowroomTypes;